import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const deleteLoginImageAPI = async () => {
  const response = await baseAPI.delete<unknown>('/studios/login-image');
  return response.data;
};

export const useDeleteLoginImageMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteLoginImageAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.STUDIO_DETAILS] });
      void queryClient.invalidateQueries({ queryKey: [KEYS.LOGIN_IMAGE] });
    },
  });
};
